import { call, put, select } from 'core/middlewares/utilities';
import { getFeatureFlag, IS_HYBRID_CART_ACTIVE } from 'core/services';
import type { RootState } from 'core/store';
import { cart } from 'core/use-cases';

export function* cartCleanUp() {
  const resellerId: RootState['user']['data']['resellerId'] = yield select(
    (rootState: RootState) => rootState.user.data.resellerId,
  );

  const isHybridCartActive: boolean = yield call(getFeatureFlag, {
    flag: IS_HYBRID_CART_ACTIVE,
    defaultValue: false,
    resellerId,
  });

  if (isHybridCartActive) {
    yield put(cart.actions.lastCartFetch.request());
  } else {
    yield put(cart.actions.cartFetch.request());
  }
}
